import React from 'react';
import { number } from 'prop-types';

import { formatCurrency } from '@ajaibid/utils';
import { colors, Row, Col, Input, Pills, Typography } from '@ajaibid/components';
import { FORM_OPTIONS } from '@context/stock/buysell';

import { useStockBuySellContext } from '../../../hooks';
import { styFormInputThresholdBtn } from '../../../style';

const InputPriceThreshold = (props) => {
  const { marginTop, marginBottom } = props;

  const { code, formState, formKey, formAction, dispatch, isBuy, isSell } =
    useStockBuySellContext();

  return (
    <>
      <Row gutters={4} marginTop={marginTop}>
        <Col size={5}>
          <Typography type="body" bold overflow="nowrap" margin={0}>
            Harga Mencapai
          </Typography>
        </Col>
        {FORM_OPTIONS.AUTO_THRESHOLD_COMPARATOR.map((v) => (
          <Col key={v.value} size="auto">
            <Pills
              fluid
              className={styFormInputThresholdBtn}
              active={formState[formKey.INPUT_THRESHOLD_COMPARATOR]?.value === v.value}
              onClick={() =>
                dispatch({ type: formAction.CHANGE_THRESHOLD_COMPARATOR, code, payload: v })
              }
              data-testid={`INPUT_THRESHOLD_COMPARATOR-${v.value}`}
            >
              {v.label}
            </Pills>
          </Col>
        ))}
        <Col>
          <Input.Number
            id={formKey.INPUT_THRESHOLD_VALUE}
            name={formKey.INPUT_THRESHOLD_VALUE}
            block
            size="sm"
            value={formState[formKey.INPUT_THRESHOLD_VALUE]}
            onChange={(e) =>
              dispatch({ type: formAction.CHANGE_THRESHOLD_VALUE, code, payload: e.target.value })
            }
          />
        </Col>
      </Row>
      <Row noGutters marginTop={8} marginBottom={marginBottom}>
        <Col size={12}>
          <Typography type="label" color={colors.NEUTRAL_7} margin={0}>
            {`Jika harga mencapai ${formatCurrency(
              formState[formKey.INPUT_THRESHOLD_VALUE],
              'IDR'
            )}, `}
            {`Auto Order akan memasukkan order kamu ke dalam antrian untuk aksi ${
              (isBuy && 'beli') || (isSell && 'jual')
            }.`}
          </Typography>
        </Col>
      </Row>
    </>
  );
};

InputPriceThreshold.propTypes = {
  marginTop: number,
  marginBottom: number,
};

InputPriceThreshold.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
};

export default InputPriceThreshold;
